// extracted by mini-css-extract-plugin
export default {"layouts":"Layouts_layouts__mzZYs"};